import React, {Component} from 'react';
import {authService} from "../../../auth";
import axios from "axios";
import * as _ from "lodash";
import mappingUtils from "../../../project/component/commons/utils/mappingUtils";
import ReadMoreReadLess from "../../../commons/ReadMoreReadLess";
import {getCDNUrl,convertUnicode} from "../../../commons/CommonFunctions";

class OtherTraining extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            pageSize: 6,
            pageNo: 0,
            pagination: false,
            training:'',
            projectType:'TRAINING'
        }
    }

    componentDidMount() {
        this.trainings();
    }

    redirect = (event,data) => {
        event.preventDefault();
        window.location.href='/project/feeds/' + data.project.slug;
    }

    trainings = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + "/backend/participation/find-project-published-applicants-details-by-userId-and-projectType/"+this.props.userId+"/"+this.state.projectType + "?page=" + this.state.pageNo + "&size=" + this.state.pageSize ,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!') {
                this.setState({training: response.data.body.content},()=>{
                    this.props.setTrainingLength(this.state.training.length);
                });
                this.setState({'pagination': response.data.body.last});

            }
        }).catch((err) => {
            console.log(err);
        });
    }

    getOptimizedImage(personalInfo) {
        if (personalInfo.resizedImages && personalInfo.resizedImages['200x200'] != null) {
            return personalInfo.resizedImages['200x200'];
        }
        return personalInfo.coverImage;
    }

    render() {
        return (
            <div id="other-prof-training" className="tab-pane fade">
                <div className="profexprow profexptraning">
                    {this.state.training && this.state.training.map((data,index)=>{
                        return  <div className="profexpblk" key={index} >
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="profexpcompany" onClick={((e) => this.redirect(e, data))}>
                                        <figure className="complogo"><img
                                            src={data && data.project && data.project.coverImage && !_.isNull(data.project.coverImage)? getCDNUrl(this.getOptimizedImage(data.project)):'https://cdn.dscovr.com/images/project-default.webp'} onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/project-default.jpg"}}
                                            alt=""/></figure>
                                        <div>
                                            <div className="row">
                                                <div className="col-md-7">

                                                    {data.project &&
                                                    <h5 dangerouslySetInnerHTML={{
                                                        __html: data.project.title
                                                            ? convertUnicode(data.project.title)
                                                                .replace(/&nbsp;/g, ' ')
                                                                .replace(/(\r\n|\r|\n)/g, '<br>')
                                                            : ''
                                                    }}/>
                                                    }
                                                </div>
                                                <div className="col-md-5 text-right">
                                                    <div className="profexptime">
                                                        {data.project  &&  data.project.beginningTime && data.project.beginningTime > new Date().getTime() ?
                                                            <span>Starting on {mappingUtils.getStartDateCustom(data.project.beginningTime)}</span> :

                                                            <span>{data.project  &&  data.project.beginningTime > 0 ?new Date(data.project.beginningTime).toLocaleDateString('en-GB', {
                                                                day: '2-digit', month: 'short', year: 'numeric'
                                                            }).replace(/ /g, '-'):'NA'}
                                                                - {data.project  &&  mappingUtils.getEndDateCustom(data.project.endingTime,data.project.lastTimeOfApplication,data.project.type)}</span>}
                                                    </div>
                                                    <span>{data.project && mappingUtils.getCity(data.project)}, {data.project && mappingUtils.getState(data.project)}, {data.project && mappingUtils.getCountry(data.project)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="profexpcomppostinfo" style={{cursor: "pointer"}} onClick={((e) => this.redirect(e, data))}>
                                        {data.project && data.project.shortBrief && data.project.id &&
                                        <ReadMoreReadLess id={data.project.id} description={convertUnicode(data.project.shortBrief)} line='2'/>
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    })}
                    {!this.state.pagination &&
                    <div className="profexprow">
                        <div className="btnblock"><a href="#profExperiencepop"
                                                     className="btn"
                                                     data-toggle="modal">Show
                            More</a></div>
                    </div>
                    }

                </div>
            </div>
        );
    }
}


export default OtherTraining;

